import React, { useState } from 'react'
import PropTypes from 'prop-types'
import _, { isEmpty } from 'lodash'
import { Button, Col, Form, Icon, Input, Modal, Radio, Row, Upload } from 'antd'
import { FormItem } from '../../../../styles/shared.style'
import { ButtonEx } from '../../../../styles/button.style'
import { useDeepEffect } from '../../../../utils/hooks'
import { beforeUpload, compressFile, getBase64 } from '../../../../utils/services'
import axios from 'axios'

const CoinPackageForm = (props) => {
  const { visible, onOk, onCancel, formData, form } = props
  const { getFieldDecorator, validateFields, setFieldsValue } = form

  useDeepEffect(() => {
    if (!isEmpty(formData)) {
      setFieldsValue({
        name: formData.name,
        coin: formData.coin,
        cost: formData.cost,
      })
    }

    return () => {
      form.resetFields()
    }
  }, [formData])

  function onSubmit(e) {
    e.preventDefault()
    validateFields(async (err, values) => {
      if (!err) {
        const data = {
          name: values.name,
          coin: values.coin,
          cost: values.cost,
        }
        if (!_.isEmpty(formData)) {
          data.packageId = formData.id
        }
        onOk(data)
      }
    })
  }

  return (
    <Modal
      title={`${!_.isEmpty(formData) ? 'Edit' : 'Create'} a Coin Package`}
      visible={visible}
      footer={null}
      onCancel={onCancel}>
      <Form form={form} onSubmit={onSubmit} layout="vertical">
        <Form.Item label="แพ็กเกจ">
          {getFieldDecorator(`name`, {
            rules: [
              {
                required: true,
                message: 'กรุณากรอก'
              }
            ]
          })(<Input
            name="name"
            placeholder="ชื่อแพ็กเกจ" />)}
        </Form.Item>
        <Form.Item label="จำนวนเหรียญ">
          {getFieldDecorator(`coin`, {
            rules: [
              {
                required: true,
                message: 'กรุณากรอก'
              }
            ]
          })(<Input
            name="coin"
            placeholder="จำนวนเหรียญ"  
            disabled={`${!_.isEmpty(formData) ? 'disabled' : ''}`}    />)}
        </Form.Item>
        <Form.Item label="ราคา">
          {getFieldDecorator(`cost`, {
            rules: [
              {
                required: true,
                message: 'กรุณากรอก'
              }
            ]
          })(<Input
            name="cost"
            placeholder="ราคา" 
            disabled={`${!_.isEmpty(formData) ? 'disabled' : ''}`}    />)}
        </Form.Item>
        <Row type="flex" gutter={8} justify="end">
          <Col>
            <Button onClick={() => onCancel()}>ยกเลิก</Button>
          </Col>
          <Col>
            <ButtonEx color="#6ebf4b" type="primary" htmlType="submit">
              บันทึก
            </ButtonEx>
          </Col>
        </Row>
      </Form>
    </Modal>
  )
}

const WrappedCoinPackageForm = Form.create({ name: 'CoinPackageForm' })(
  CoinPackageForm
)
export default WrappedCoinPackageForm
